import { Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Button, ButtonProps } from './Button';
import { Icon, ICONS } from './Icon';
import { ViewWithSeparators } from './ViewWithSeparators';

export type PageEmptyProps = {
  icon?: ICONS;
  iconCircled?: boolean;
  text?: string;
  subtext?: string;
  subtextHeight?: number;
  button?: ButtonProps;
  style?: StyleProp<ViewStyle>;
  backgroundColor?: (typeof theme.colors)[keyof typeof theme.colors];
  children?: React.ReactNode;
};
export const PageEmpty: React.FC<PageEmptyProps> = ({
  backgroundColor = theme.colors.background,
  button,
  icon,
  iconCircled = true,
  style,
  text,
  subtext,
  subtextHeight,
  children,
}) => {
  return (
    <ViewWithSeparators
      separatorMargin={theme.paddingVertical}
      style={[
        {
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: theme.paddingVertical,
          paddingBottom: theme.paddingVertical,
          paddingHorizontal: theme.paddingHorizontal,
          flex: 1,
          pointerEvents: 'box-none',
        },
        style,
      ]}
    >
      {!!icon && (
        <View
          style={[
            iconCircled
              ? {
                  backgroundColor: '#DFDFDF',
                  borderRadius: 60 + theme.grid * 3,
                  padding: theme.grid * 3,
                }
              : undefined,
            { pointerEvents: 'none' },
          ]}
        >
          <Icon
            source={icon}
            size={120 + (iconCircled ? 0 : theme.grid * 6)}
            color={iconCircled ? backgroundColor : '#DFDFDF'}
          />
        </View>
      )}
      {(!!text || !!subtext) && (
        <View style={{ pointerEvents: 'none' }}>
          {!!text && (
            <Txt
              size="large"
              style={{
                color: '#999',
                textAlign: 'center',
              }}
            >
              {text}
            </Txt>
          )}
          {!!subtext && (
            <View style={{ height: subtextHeight }}>
              <Txt
                size="small"
                style={{
                  color: '#999',
                  textAlign: 'center',
                }}
              >
                {subtext}
              </Txt>
            </View>
          )}
        </View>
      )}
      {button && (
        <Button {...button} style={[button.style, { marginHorizontal: 0 }]} />
      )}
      {children}
    </ViewWithSeparators>
  );
};
